module.exports = __webpack_public_path__ + "media/images/logo-adcurve-light-bg-787fd81be69d460d9aa5788746fc5f95.svg";